module.exports = __webpack_public_path__ + "media/images/new_home/okra-img-6fd067f75cf1ad68ef76c244be60ea44.png";